import React, { useState } from "react";
import "../Styles-css/Contact.css";
import {
  FaClock,
  FaEnvelope,
  FaMapMarkerAlt,
  FaMobileAlt,
} from "react-icons/fa";
import axios from "axios";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submissionStatus, setSubmissionStatus] = useState(null); // 'success', 'error', null

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus("loading");

    const jsonData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contacts`,
        jsonData
      );
      console.log("Contact message submitted successfully:", response.data);
      setSubmissionStatus("success");
      setFormData({ name: "", email: "", phone: "", message: "" }); // Clear form
    } catch (error) {
      console.error("Error submitting contact message:", error);
      setSubmissionStatus("error");
    }
  };

  return (
    <>
      <section className="hero">
        <h1 className="contact-h1">Contact us</h1>
        <p className="contact-p">
          Have questions, feedback, or need assistance? We’re here to help! Fill
          out the form below, and our team will get back to you as soon as
          possible. You can also reach us directly via email or phone for urgent
          inquiries. We look forward to hearing from you!
        </p>
      </section>
      <div className="contact-container">
        <div className="contact-info">
          <h2 className="contact-heading">To Know More About Properties</h2>
          <div className="contact-details">
            <div className="info-item">
              <div>
                <h4>
                  <FaMapMarkerAlt className="contact-icon" />
                  Our Address{" "}
                </h4>
                <p>
                  Z-15 First Floor Sheela Arcade<br /> 
                  Near HDFC Bank Zone-1 MP Nagar <br />
                  Bhopal, Madhya Pradesh 
                  
                </p>
              </div>

              <div>
                <h4>
                  <FaMobileAlt className="contact-icon" />
                  Contact Us
                </h4>
                <p>+(91) 7898622741</p>
                <p>+(91) 9109668955</p>
              </div>
            </div>

            <div className="info-item">
              <div>
                <h4>
                  <FaEnvelope className="contact-icon" /> Email Us
                </h4>
                <p>indiakirayawala@gmail.com</p>
                
              </div>
              <div>
                <h4>
                  <FaClock className="contact-icon" /> Working Hours
                </h4>
                <p>Mon-Fri: 8 AM - 8 PM</p>
                <p>Sat-Sun: 10 AM - 8 PM</p>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-form">
          <h1>Contact Here....</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Name*"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                placeholder="Email*"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel" // Changed to tel for phone number input
                placeholder="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
              {/* Removed date and time inputs as per your provided fields */}
            </div>
            <div className="form-group">
              <textarea
                placeholder="Additional Message"
                className="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button
              type="submit"
              className="cont-btn"
              disabled={submissionStatus === "loading"}
            >
              {submissionStatus === "loading" ? "Submitting..." : "Submit"}
            </button>

            {submissionStatus === "success" && (
              <p className="success-message">Message sent successfully!</p>
            )}
            {submissionStatus === "error" && (
              <p className="error-message">
                Failed to send message. Please try again.
              </p>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
